// extracted by mini-css-extract-plugin
export var errorsContainer = "_st-1";
export var link = "_st-0";